import { render } from "./ModalHeader.vue?vue&type=template&id=4824f442"
import script from "./ModalHeader.vue?vue&type=script&lang=js"
export * from "./ModalHeader.vue?vue&type=script&lang=js"
script.render = render

export default script